// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"EA-z","expressButtonContainerWithPayPal":"FA-z","expressButton":"GA-z","or":"HA-z"};